/* iSYFIX Variant Facts v3.6 — motor de variantes del PDP:
   (1) hechos condicionales [data-when] por variante seleccionada,
   (2) evento isyfix:variant con ejes actuales,
   (3) picker virtual/configurable de N ejes (variant_axes / picker_config):
       estilos buttons | circle | square | photo | dropdown, con alt opcional,
       orden opcional por eje via picker_config[axis].order (lista de valores),
       grupos con etiqueta visible via picker_config[axis].groups
         ([{label, values:[...]}]) — separa p.ej. Standard/Metallic/Reflective,
       variante por defecto via picker_config._default ({Eje:valor}) cuando no
         hay ?variant en la URL; swatch con color hex de respaldo (nunca en blanco)
         y acabado metalico via sw.sheen (CSS background-image, sin base64),
   (4) galería por variante (media_sets):
       v2 "rules": [{when:{Eje:[valores]}, media:[ids], extra?:bool}] — unión de
       reglas que cumple la variante + global; las reglas extra:true solo AÑADEN
       media (p.ej. video) y no definen el set por sí solas; sin regla primaria
       aplicable → se muestra todo (fallback). v1 (match/sets) sigue soportado.
       Thumbs visibles ORDENADOS según la regla (main primero, via flex order);
       contador renumerado sobre visibles; video como slide reproducible.
   Todo aditivo: opera el picker físico oculto; el buybox conserva precio/URL/carrito. */
(function () {
  if (window.__ixVariantFacts) return;
  window.__ixVariantFacts = true;

  var current = {};
  var D = null;

  /* ===== Hechos condicionales ===== */
  function parseWhen(el) { try { return JSON.parse(el.getAttribute('data-when')); } catch (e) { return null; } }
  function matches(w) {
    if (!w) return true;
    return Object.keys(w).every(function (k) {
      var allowed = w[k];
      if (!Array.isArray(allowed)) allowed = [allowed];
      var cur = current[k];
      return cur != null && allowed.indexOf(cur) > -1;
    });
  }
  function applyFacts() {
    document.querySelectorAll('[data-when]').forEach(function (el) { el.hidden = !matches(parseWhen(el)); });
  }

  /* ===== Galería por variante ===== */
  function visibleMediaIds() {
    var ms = D && D.mediaSets;
    if (!ms) return null;
    var ids = [];
    (ms.global || []).forEach(function (id) { ids.push(String(id)); });
    if (ms.rules && ms.rules.length) {
      var any = false;
      ms.rules.forEach(function (r) {
        if (matches(r.when)) {
          if (!r.extra) any = true;
          (r.media || []).forEach(function (id) { var s = String(id); if (ids.indexOf(s) === -1) ids.push(s); });
        }
      });
      return any ? ids : null; /* ninguna regla primaria aplica → mostrar todo */
    }
    if (ms.sets) {
      var key = (ms.match || []).map(function (a) { return current[a] != null ? current[a] : '?'; }).join('|');
      var set = ms.sets[key];
      if (set) set.forEach(function (id) { ids.push(String(id)); });
      return set ? ids : null;
    }
    return null;
  }
  function updateCounters() {
    document.querySelectorAll('.ix-product__rail').forEach(function (rail) {
      var vis = [];
      rail.querySelectorAll('[data-thumb]').forEach(function (t) { if (!t.hidden) vis.push(t); });
      if (!vis.length) return;
      vis.sort(function (a, b) { return (parseInt(a.style.order, 10) || 0) - (parseInt(b.style.order, 10) || 0); });
      var pos = 0;
      for (var i = 0; i < vis.length; i++) { if (vis[i].classList.contains('is-active')) { pos = i; break; } }
      var root = rail.closest('.ix-product') || document;
      var counter = root.querySelector('[data-counter]');
      if (counter) counter.textContent = (pos + 1) + ' / ' + vis.length;
    });
  }
  function applyGallery() {
    var vis = visibleMediaIds();
    var thumbs = document.querySelectorAll('[data-thumb]');
    if (!thumbs.length) return;
    if (!vis) { thumbs.forEach(function (t) { t.hidden = false; t.style.order = ''; }); updateCounters(); return; }
    var activeVisible = false;
    thumbs.forEach(function (t) {
      var idx = parseInt(t.getAttribute('data-index'), 10);
      var m = D.media && D.media[idx];
      var pos = m ? vis.indexOf(String(m.id)) : -1;
      var show = m ? pos > -1 : true;
      t.hidden = !show;
      t.style.order = pos > -1 ? String(pos) : '';
      if (show && t.classList.contains('is-active')) activeVisible = true;
    });
    if (!activeVisible) {
      var first = null;
      thumbs.forEach(function (t) { if (!first && !t.hidden && t.style.order === '0') first = t; });
      if (!first) first = document.querySelector('[data-thumb]:not([hidden])');
      if (first) first.click();
    }
    updateCounters();
  }
  function stage() { return document.querySelector('[data-stage]'); }
  function killVideo() {
    var v = document.querySelector('.ix-stage-video');
    if (v) v.remove();
  }
  function playVideo(m) {
    var st = stage();
    if (!st) return;
    killVideo();
    var wrap = document.createElement('div');
    wrap.className = 'ix-stage-video';
    if (m.type === 'external_video' && m.ext) {
      var src = m.host === 'vimeo' ? 'https://player.vimeo.com/video/' + m.ext + '?autoplay=1' : 'https://www.youtube.com/embed/' + m.ext + '?autoplay=1&rel=0';
      wrap.innerHTML = '<iframe src="' + src + '" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen title="Product video"></iframe>';
    } else { return; }
    st.appendChild(wrap);
  }
  function watchGalleryClicks() {
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var t = e.target.closest('[data-thumb]');
      if (!t) return;
      var idx = parseInt(t.getAttribute('data-index'), 10);
      var m = D && D.media && D.media[idx];
      setTimeout(function () {
        if (m && m.type === 'external_video') playVideo(m); else killVideo();
        updateCounters();
      }, 0);
    }, true);
  }

  /* ===== Ejes ===== */
  function physicalGroups() {
    return Array.prototype.slice.call(document.querySelectorAll('.ix-product__opt[data-option-index]'));
  }
  function axesModel() {
    if (D && D.vax && D.vax.variants) return D.vax;
    if (D && D.pickerConfig && D.variantOptions && D.optionNames && D.optionNames.length) {
      var model = { axes: D.optionNames.slice(), variants: {} };
      Object.keys(D.variantOptions).forEach(function (sku) {
        var m = {};
        D.optionNames.forEach(function (n, i) { if (D.variantOptions[sku][i] != null) m[n] = D.variantOptions[sku][i]; });
        model.variants[sku] = m;
      });
      return model;
    }
    return null;
  }
  var MODEL = null;
  function axesFromPhysical() {
    var axes = {};
    var groups = physicalGroups();
    if (!D) return axes;
    groups.forEach(function (g, i) {
      var name = D.optionNames[i];
      var active = g.querySelector('[data-opt-btn].is-active');
      if (name && active) axes[name] = active.getAttribute('data-value');
    });
    if (!groups.length && D.optionNames) {
      D.optionNames.forEach(function (n, i) { if (D.currentOptions[i] != null) axes[n] = D.currentOptions[i]; });
    }
    return axes;
  }
  function announce() {
    try { window.dispatchEvent(new CustomEvent('isyfix:variant', { detail: { axes: current, sku: D && D.currentSku } })); } catch (e) {}
    applyFacts();
    applyGallery();
    decorateTiles();
  }

  /* ===== Decoración de tiles (1a/1b): precio real por opción + barra proporcional =====
     Precio: bajo cada botón de texto, SOLO si el precio varía entre los valores del eje
     (dado el resto de la selección actual) — datos de [data-variant-data], nunca inventados.
     Barra: ejes cuyos valores son pulgadas ("3 Inch"…) llevan barra con width % del máximo. */
  var PRICES = null;
  function loadPrices() {
    if (PRICES) return PRICES;
    var el = document.querySelector('[data-variant-data]');
    if (!el) return null;
    try { PRICES = JSON.parse(el.textContent); } catch (e) { PRICES = null; }
    return PRICES;
  }
  function fmtMoney(c) { return '$' + (c / 100).toFixed(2); }
  function tileGroups() {
    var out = [];
    if (D && D.optionNames) {
      physicalGroups().forEach(function (g, i) {
        var axis = D.optionNames[i];
        if (!axis || g.offsetParent === null) return; /* grupos físicos ocultos por el picker virtual */
        var btns = [];
        g.querySelectorAll('[data-opt-btn]').forEach(function (b) { btns.push({ el: b, val: b.getAttribute('data-value') }); });
        if (btns.length) out.push({ axis: axis, buttons: btns });
      });
    }
    document.querySelectorAll('[data-ix-axis]').forEach(function (g) {
      var axis = g.getAttribute('data-ix-axis');
      var btns = [];
      g.querySelectorAll('[data-ix-axis-btn].ix-product__tile').forEach(function (b) { btns.push({ el: b, val: b.getAttribute('data-value') }); });
      if (btns.length) out.push({ axis: axis, buttons: btns });
    });
    return out;
  }
  function priceFor(axis, val) {
    var list = loadPrices();
    if (!list || !D || !D.optionNames) return null;
    var best = null;
    for (var i = 0; i < list.length; i++) {
      var opts = list[i].options || [];
      var exact = true, score = 0;
      for (var j = 0; j < D.optionNames.length; j++) {
        var n = D.optionNames[j];
        if (n === axis) {
          if (opts[j] !== val) { exact = false; break; }
        } else if (current[n] != null && opts[j] === current[n]) {
          score++;
        }
      }
      if (!exact) continue;
      if (!best || score > best.score) best = { p: list[i].price, score: score };
    }
    return best ? best.p : null;
  }
  var INCH_RE = /^(\d+(?:\.\d+)?)\s*(?:in|inch|inches)\b/i;
  function decorateTiles() {
    tileGroups().forEach(function (grp) {
      /* barra proporcional (solo si TODOS los valores son pulgadas) */
      var sizes = grp.buttons.map(function (b) { var m = INCH_RE.exec(b.val); return m ? parseFloat(m[1]) : null; });
      if (!sizes.some(function (s) { return s == null; })) {
        var max = Math.max.apply(null, sizes);
        if (max) {
          grp.buttons.forEach(function (b, i) {
            if (b.el.querySelector('.ix-tile-bar')) return;
            var bar = document.createElement('span');
            bar.className = 'ix-tile-bar';
            bar.style.width = Math.max(16, Math.round((sizes[i] / max) * 100)) + '%';
            b.el.appendChild(bar);
          });
        }
      }
      /* precio por opción (solo si varía dentro del eje) */
      var prices = grp.buttons.map(function (b) { return priceFor(grp.axis, b.val); });
      var known = prices.filter(function (p) { return p != null; });
      var vary = known.length > 1 && known.some(function (p) { return p !== known[0]; });
      grp.buttons.forEach(function (b, i) {
        var span = b.el.querySelector('.ix-tile-price');
        if (!vary || prices[i] == null) { if (span) span.remove(); return; }
        if (!span) {
          span = document.createElement('span');
          span.className = 'ix-tile-price';
          b.el.appendChild(span);
        }
        span.textContent = fmtMoney(prices[i]);
      });
    });
  }

  /* ===== Picker virtual/configurable ===== */
  function axisValues(axis) {
    var seen = [];
    Object.keys(MODEL.variants).forEach(function (sku) {
      var v = MODEL.variants[sku][axis];
      if (v != null && seen.indexOf(v) === -1) seen.push(v);
    });
    var allNum = seen.every(function (s) { return /^\d+(\.\d+)?$/.test(s); });
    if (allNum) seen.sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
    return seen;
  }
  function findSku(want) {
    var best = null, bestScore = -1;
    Object.keys(MODEL.variants).forEach(function (sku) {
      var ax = MODEL.variants[sku];
      if (want.__must && ax[want.__must] !== want[want.__must]) return;
      var score = 0;
      MODEL.axes.forEach(function (a) { if (want[a] != null && ax[a] === want[a]) score++; });
      var avail = (D.availableSkus || []).indexOf(sku) > -1 ? 0.5 : 0;
      if (score + avail > bestScore) { bestScore = score + avail; best = sku; }
    });
    return best;
  }
  function defaultSku() {
    var d = D && D.pickerConfig && D.pickerConfig._default;
    if (!d || !MODEL) return null;
    var keys = MODEL.axes.filter(function (a) { return d[a] != null; });
    if (!keys.length) return null;
    var want = {};
    keys.forEach(function (a) { want[a] = d[a]; });
    want.__must = keys[0];
    return findSku(want);
  }
  function clickPhysicalFor(sku) {
    var vo = D.variantOptions[sku];
    if (!vo) return;
    physicalGroups().forEach(function (g, i) {
      if (vo[i] == null) return;
      var btn = g.querySelector('[data-opt-btn][data-value="' + (window.CSS && CSS.escape ? CSS.escape(vo[i]) : vo[i]) + '"]');
      if (btn && !btn.classList.contains('is-active')) btn.click();
    });
  }
  function checkColorFor(sw) {
    /* color del ✓ del swatch activo por luminancia (1c): claro → check ink, oscuro → check blanco */
    var hex = sw.color || (sw.gradient ? String(sw.gradient).split('|')[0] : null);
    if (!hex || !/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(String(hex).trim())) return '#FFFFFF';
    hex = String(hex).trim().slice(1);
    if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    var r = parseInt(hex.slice(0, 2), 16), g = parseInt(hex.slice(2, 4), 16), b = parseInt(hex.slice(4, 6), 16);
    return (0.299 * r + 0.587 * g + 0.114 * b) > 175 ? '#0A0A0A' : '#FFFFFF';
  }
  function swatchFor(axis, val) {
    var cfg = (D.pickerConfig || {})[axis];
    var sw = cfg && cfg.swatches ? cfg.swatches[val] : null;
    if (sw == null) return null;
    if (typeof sw === 'string') return { color: sw };
    return sw;
  }
  function selectSku(sku) {
    if (!sku) return;
    D.currentSku = sku;
    clickPhysicalFor(sku);
    syncVirtual();
  }
  function syncVirtual() {
    var axes = MODEL.variants[D.currentSku] || {};
    document.querySelectorAll('[data-ix-axis]').forEach(function (g) {
      var axis = g.getAttribute('data-ix-axis');
      var head = g.querySelector('[data-ix-axis-value]');
      if (head && axes[axis] != null) {
        var sw = swatchFor(axis, axes[axis]);
        head.textContent = (sw && sw.alt) ? sw.alt : axes[axis];
        var cnt = g.getAttribute('data-ix-count');
        if (cnt && axis.toLowerCase() === 'color') head.textContent += ' · ' + cnt + ' colors';
      }
      var sel = g.querySelector('select[data-ix-axis-select]');
      if (sel && axes[axis] != null) sel.value = axes[axis];
      g.querySelectorAll('[data-ix-axis-btn]').forEach(function (b) {
        var val = b.getAttribute('data-value');
        var on = val === axes[axis];
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var probe = {}; MODEL.axes.forEach(function (a) { probe[a] = axes[a]; });
        probe[axis] = val; probe.__must = axis;
        var cand = findSku(probe);
        var exact = cand && MODEL.variants[cand][axis] === val;
        b.classList.toggle('is-dim', !exact);
      });
    });
    current = {};
    MODEL.axes.forEach(function (a) { if (axes[a] != null) current[a] = axes[a]; });
    announce();
  }
  function makeAxisButton(axis, val, style) {
    var b = document.createElement('button');
    b.type = 'button';
    b.setAttribute('data-ix-axis-btn', '');
    b.setAttribute('data-value', val);
    var sw = (style === 'circle' || style === 'square' || style === 'photo') ? swatchFor(axis, val) : null;
    if (sw) {
      b.className = 'ix-swatch-btn' + (style !== 'circle' ? ' ix-swatch-btn--' + style : '');
      b.style.setProperty('--ix-check', checkColorFor(sw));
      var label = sw.alt || val;
      b.setAttribute('aria-label', label);
      b.title = label;
      if (style === 'photo' && sw.image) {
        var img = document.createElement('img');
        img.className = 'ix-swatch';
        if (sw.color) img.style.backgroundColor = sw.color; /* fallback behind a slow/broken image */
        img.src = sw.image;
        img.alt = label;
        img.loading = 'lazy';
        b.appendChild(img);
      } else {
        var span = document.createElement('span');
        span.className = 'ix-swatch' + (sw.border ? ' ix-swatch--bordered' : '');
        span.style.backgroundColor = sw.color || '#E5E5E5'; /* set color FIRST: swatch can never render blank */
        if (sw.sheen) {
          span.style.backgroundImage = String(sw.sheen); /* full CSS background-image (metallic sheen); no base64 */
        } else if (sw.gradient) {
          var parts = String(sw.gradient).split('|');
          span.style.backgroundImage = 'linear-gradient(135deg, ' + parts[0] + ', ' + (parts[1] || parts[0]) + ')'; /* degradado suave (1c), no corte duro */
        } else if (sw.image) {
          span.style.backgroundImage = 'url("' + sw.image + '")'; /* quoted url: data URIs never break el token */
          span.style.backgroundSize = 'cover';
          span.style.backgroundPosition = 'center';
        }
        b.appendChild(span);
      }
    } else {
      b.className = 'ix-product__tile';
      b.textContent = axis === 'Pack' ? val + ' Pack' : val;
    }
    b.addEventListener('click', function () {
      var cur = MODEL.variants[D.currentSku] || {};
      var want = {}; MODEL.axes.forEach(function (a) { want[a] = cur[a]; });
      want[axis] = val; want.__must = axis;
      selectSku(findSku(want));
    });
    return b;
  }
  function buildVirtual() {
    var groups = physicalGroups();
    if (!groups.length) return;
    var host = groups[0].parentElement;
    var wrap = document.createElement('div');
    wrap.setAttribute('data-ix-virtual', '');
    MODEL.axes.forEach(function (axis) {
      var vals = axisValues(axis);
      if (!vals.length) return;
      var cfg = (D.pickerConfig || {})[axis] || {};
      if (cfg.order && cfg.order.length) {
        var _o = cfg.order;
        vals = vals.slice().sort(function (a, b) {
          var ia = _o.indexOf(a); if (ia < 0) ia = 1e9;
          var ib = _o.indexOf(b); if (ib < 0) ib = 1e9;
          return ia - ib;
        });
      }
      var style = cfg.style || 'buttons';
      /* Medida en BOTONES (Eduardo 16-jul): dropdown solo si el eje tiene >10 valores */
      if (style === 'dropdown' && vals.length <= 10) style = 'buttons';
      var g = document.createElement('div');
      g.className = 'ix-product__opt';
      if (style === 'circle' || style === 'square' || style === 'photo') {
        g.className += ' ix-opt--swatches';
        g.setAttribute('data-ix-count', String(vals.length));
      }
      g.setAttribute('data-ix-axis', axis);
      var displayAxis = axis === 'Pack' ? 'Pack Qty' : axis;
      g.innerHTML = '<div class="ix-product__opt-head"><span class="ix-product__opt-name">' + displayAxis + '</span><span class="ix-product__opt-value" data-ix-axis-value></span></div><div class="ix-product__opt-grid"></div>';
      var grid = g.querySelector('.ix-product__opt-grid');
      if (style === 'dropdown') {
        var sel = document.createElement('select');
        sel.className = 'ix-axis-select';
        sel.setAttribute('data-ix-axis-select', '');
        sel.setAttribute('aria-label', displayAxis);
        vals.forEach(function (val) {
          var o = document.createElement('option');
          o.value = val; o.textContent = axis === 'Pack' ? val + ' Pack' : val;
          sel.appendChild(o);
        });
        sel.addEventListener('change', function () {
          var cur = MODEL.variants[D.currentSku] || {};
          var want = {}; MODEL.axes.forEach(function (a) { want[a] = cur[a]; });
          want[axis] = sel.value; want.__must = axis;
          selectSku(findSku(want));
        });
        grid.appendChild(sel);
      } else if (cfg.groups && cfg.groups.length) {
        var covered = {};
        cfg.groups.forEach(function (grp) {
          var gv = (grp.values || []).filter(function (v) { return vals.indexOf(v) > -1; });
          if (!gv.length) return;
          if (grp.label) {
            var lab = document.createElement('div');
            lab.className = 'ix-swatch-group-label';
            lab.textContent = grp.label;
            lab.style.cssText = 'grid-column:1/-1;flex-basis:100%;width:100%;font-size:10px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:#6b7280;margin:8px 0 2px;';
            grid.appendChild(lab);
          }
          gv.forEach(function (val) { covered[val] = 1; grid.appendChild(makeAxisButton(axis, val, style)); });
        });
        vals.forEach(function (val) { if (!covered[val]) grid.appendChild(makeAxisButton(axis, val, style)); });
      } else {
        vals.forEach(function (val) { grid.appendChild(makeAxisButton(axis, val, style)); });
      }
      wrap.appendChild(g);
    });
    host.insertBefore(wrap, groups[0]);
    syncVirtual();
  }

  /* ===== Boot ===== */
  function boot() {
    var dataEl = document.querySelector('script[data-ix-axes-data]');
    if (dataEl) { try { D = JSON.parse(dataEl.textContent); } catch (e) { D = null; } }
    var seed = document.querySelector('script[data-ix-current-axes]');
    if (seed) { try { current = JSON.parse(seed.textContent) || {}; } catch (e) {} }
    if (!D) { applyFacts(); return; }
    watchGalleryClicks();
    MODEL = axesModel();
    if (MODEL && (D.vax || D.pickerConfig) && Object.keys(MODEL.variants).length) {
      var hasUrlVariant = false;
      try { hasUrlVariant = !!(new URLSearchParams(location.search).get('variant')); } catch (e) {}
      if (!hasUrlVariant) {
        var ds = defaultSku();
        if (ds) D.currentSku = ds; /* open on picker_config._default (e.g. Black) unless URL pins a variant */
      }
      if (!MODEL.variants[D.currentSku]) {
        var first = Object.keys(MODEL.variants)[0];
        if (!D.currentSku || !MODEL.variants[D.currentSku]) D.currentSku = first;
      }
      buildVirtual();
    } else {
      current = axesFromPhysical();
      announce();
      document.addEventListener('click', function (e) {
        if (!e.target || !e.target.closest) return;
        if (!e.target.closest('[data-opt-btn]')) return;
        setTimeout(function () {
          current = axesFromPhysical();
          announce();
        }, 0);
      }, true);
    }
  }

  window.addEventListener('isyfix:variant', function (e) {
    if (e.detail && e.detail.axes && e.detail.axes !== current) { current = e.detail.axes; applyFacts(); }
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
